export const RESUME_SEARCH_DISPLAY_PAGE_SIZE = 10;
export const METADATA_VALUES_DISPLAY_PAGE_SIZE = 50;

export const MAX_AD_HOC_CSV_SIZE = 5000;
